// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__-SX5J","box":"style_box__N7vHP","active":"style_active__Tl+w0","title":"style_title__rQsGY","item":"style_item__NFiK9"};